import styled, { css } from 'styled-components'
export const Component = styled.div`
  position: relative;
  width: 100%;
  max-width: 350px;
  .input-container {
    border: 3px solid #333;
    border-radius: 4px;
    width: 100%;
    min-height: 40px;
    position: relative;
    background: #e7e7e7;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    .close-icon {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      svg {
        fill: #ccc;
        width: 25px !important;
        height: 25px !important;
      }
    }
  }
`
export const TimeInput = styled.input`
  width: calc(100% - 40px);
  appearance: none;
  outline: none;
  border: none !important;
  background: transparent;
  min-height: 35px;
  height: 100%;
`

export const TimeModal = styled.div`
  position: absolute;
  top: 100%;
  left: 0%;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  margin-top: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  padding: 10px;
  display: flex;
  justify-content: center;
  ${({ isOpen }) =>
    isOpen === false &&
    css`
      opacity: 0;
      visibility: none;
    `}
  .column {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .scroll-container {
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .carousel-root {
      min-width: 80px;
    }
    .carousel-slider {
      height: 80px;
      width: 80px;
      display: flex;
      align-items: center;
      background: #e7e7e7;
      border-radius: 4px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
    }
    .control-arrow {
      height: 20px;
      width: 20px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      &::before {
        display: none !important;
      }
      &.control-next {
        top: 0%;
        left: 50%;
        transform: translateX(-50%);
        background: black;
      }
      &.control-prev {
        top: 100%;
        left: 50%;
        transform: translate(-50%, -100%);
        margin-bottom: 1px;
        background: black;
      }
    }
    .carousel-status {
      display: none;
    }
    .box {
      font-weight: 800;
      font-size: 30px;
      color: #11111180;
    }
    .thumbs-wrapper {
      margin: 0px;
      display: none;
    }
  }
`
